import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const AlertMissingTable = (props) => {    
    return (
        <TableContainer component={Paper} sx={{height:550}}>
            <Table sx={{ minWidth: 750 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Local Experiment ID</TableCell>
                        <TableCell>Experiment ID</TableCell>
                        <TableCell>Owner</TableCell>
                        <TableCell>Load Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.rows.map((row) => (
                        <TableRow
                            key={row.LocalExperimentID}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell> {row.LocalExperimentID} </TableCell>
                            <TableCell> {row.ExperimentID} </TableCell>
                            <TableCell> {row.Owner} </TableCell>
                            <TableCell> {row.LOADDATE} </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
  }

  export default AlertMissingTable;